import React, { useEffect, useState } from 'react'
import { ETMAccountManagemnetModal, SupplierProps } from './SupplierUtils'
import { ApiNotRespondMessage, isValidEmail, onlyAlphabets, onlyNumeric } from '../../../commonClass/CommonValidation';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { patchUsersData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage } from '../../../commonClass/Session';

const ETMAccountManagemnet = (props: SupplierProps) => {
    const { SupplierId, disable, editdisable, cleardisable, type, retrieveData, UserId, SupplierName } = props;

    const dispatch = useDispatch();

    const [formValue, setFormValue] = useState(new ETMAccountManagemnetModal());
    const [formError, setFormError] = useState<any>(null);

    const [addbuttontext, setAddButtonText] = useState(type === "Edit" ? "Update" : "Save");
    const [disabled, setDisabled] = useState(disable);
    const [editDisabled, setEditDisabled] = useState(editdisable);


    //#region retrieve data
    useEffect(() => {
        setFormValue((form) => ({
            ...form,
            SupplierId: SupplierId,
            UserId: UserId
        }));
        if (retrieveData) {
            setFormValue((form) => ({
                ...form,
                supplierMngtId: retrieveData?.supplierMngtId ? retrieveData?.supplierMngtId : 0,
                kamName: retrieveData?.kamName ? retrieveData?.kamName : "",
                kamEmail: retrieveData?.kamEmail ? retrieveData?.kamEmail : "",
                kamMobNo: retrieveData?.kamMobNo ? retrieveData?.kamMobNo : "",
                amName: retrieveData?.amName ? retrieveData?.amName : "",
                amEmail: retrieveData?.amEmail ? retrieveData?.amEmail : "",
                amMobNo: retrieveData?.amMobNo ? retrieveData?.amMobNo : "",
                mName: retrieveData?.mName ? retrieveData?.mName : "",
                mEmail: retrieveData?.mEmail ? retrieveData?.mEmail : "",
                mMobileNo: retrieveData?.mMobileNo ? retrieveData?.mMobileNo : "",
            }))
        }
    }, [retrieveData, UserId, SupplierId])
    //#endregion


    const handleOnChange = (name: string, value: string) => {
        setEditDisabled(false);
        setFormError(null);
        setFormValue((form) => ({ ...form, [name]: value }));
    }

    const validateData = () => {
        let status = true;
        let error: any = {}

        if (formValue?.kamEmail && !isValidEmail(formValue?.kamEmail)) {
            error.kamEmail = "Email id should in a format abc@xyz.com";
            status = false;
        }
        if (formValue?.kamMobNo && formValue?.kamMobNo?.trim()?.length < 10) {
            error.kamMobNo = "Kindly enter the correct mobile number";
            status = false;
        }

        if (formValue?.amEmail && !isValidEmail(formValue?.amEmail)) {
            error.amEmail = "Email id should in a format abc@xyz.com";
            status = false;
        }
        if (formValue?.amMobNo && formValue?.amMobNo?.trim()?.length < 10) {
            error.amMobNo = "Kindly enter the correct mobile number";
            status = false;
        }

        if (formValue?.mName?.trim()?.length <= 0) {
            error.ManagerName = "Kindly Enter your Name";
            status = false;
        }
        if (formValue?.mEmail?.trim()?.length <= 0) {
            error.EmailId = "Kindly Enter your Email";
            status = false;
        }
        if (formValue?.mEmail && !isValidEmail(formValue?.mEmail)) {
            error.EmailId = "Email id should in a format abc@xyz.com";
            status = false;
        }
        if (formValue?.mMobileNo?.trim()?.length <= 0) {
            error.MobileNo = "Kindly enter the mobile number";
            status = false;
        }
        if (formValue?.mMobileNo && formValue?.mMobileNo?.trim()?.length < 10) {
            error.MobileNo = "Kindly enter the correct mobile number";
            status = false;
        }

        setFormError(error);
        return status;
    }

    const handleSaveUpdate = async () => {
        if (validateData()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                const insertUpdateSupplierContact = formValue?.supplierMngtId > 0 ?
                    await patchUsersData('/midoffice/v1/updatecontact', formValue)
                    :
                    await postUsersData('/midoffice/v1/insertcontact', formValue)
                if (insertUpdateSupplierContact?.status) {
                    dispatch({ type: 'ALERTINGMESSAGE', message: insertUpdateSupplierContact?.message || ApiNotRespondMessage, path: "/supplier-list" });
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch({ type: 'ALERTING', message: insertUpdateSupplierContact?.message || ApiNotRespondMessage });
                    dispatch(loaderActions.end());
                }
            }
            else {
                dispatch(loaderActions.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }
        }
    }
    const handleClear = (e: any) => {
        e.preventDefault();
        setFormError(null);
        setFormValue((form) => ({
            ...form,
            kamName: '',
            kamEmail: '',
            kamMobNo: '',
            amName: '',
            amEmail: '',
            amMobNo: '',
            mName: '',
            mEmail: '',
            mMobileNo: '',
        }));

    }

    return (
        <div className="container-fluid form_border my-5">
            <form action="" >
                <div className="mb-1 mt-4 col-lg-10">
                    <div className='row'>
                        <div className="col-lg-6 col-sm-6 mb-3">
                            <div className="row">
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className='col-form-label required'>Name of Company</label>
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input
                                        className='form-control'
                                        type="text"
                                        value={SupplierName || ""}
                                        disabled
                                        placeholder='Company Name'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6"></div>
                        <div className='col-lg-12 col-md-12 col-sm-12 mb-2'>
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <h5 className="">Key Account Manager</h5>
                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label">Full Name</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        name="kamName"
                                        value={formValue.kamName}
                                        onChange={(e: any) => handleOnChange(e.target.name, onlyAlphabets(e.target.value))}
                                        disabled={disabled ? true : false}
                                        placeholder='Full Name'
                                        maxLength={250}
                                    />
                                    {/* {formError.SupplierName && <p className='text-danger text-start'>{formError.SupplierName}</p>} */}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label">Email ID</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id="kamEmail"
                                        name="kamEmail"
                                        value={formValue.kamEmail}
                                        onChange={(e: any) => handleOnChange(e.target.name, e.target.value)}
                                        disabled={disabled ? true : false}
                                        placeholder='Email ID'
                                        maxLength={150}
                                    />
                                    {formError?.kamEmail && <div className='text-danger fs_14'>{formError?.kamEmail}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label">Mobile Number</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <div className="input-group">
                                        <span className="input-group-text" id="prefixMobile"> +91 </span>
                                        <input className="form-control"
                                            type="text"
                                            id="kamMobNo"
                                            name="kamMobNo"
                                            value={formValue.kamMobNo}
                                            onChange={(e: any) => handleOnChange(e.target.name, onlyNumeric(e.target.value))}
                                            disabled={disabled ? true : false}
                                            placeholder='Mobile Number'
                                            maxLength={10}
                                        />
                                    </div>
                                    {formError?.kamMobNo && <div className='text-danger fs_14'>{formError?.kamMobNo}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-12 col-md-12 col-sm-12 mt-3 mb-2'>
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <h5 className="">Assistant Manager</h5>
                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label">Full Name</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        name="amName"
                                        value={formValue.amName}
                                        onChange={(e: any) => handleOnChange(e.target.name, onlyAlphabets(e.target.value))}
                                        disabled={disabled ? true : false}
                                        placeholder='Full Name'
                                        maxLength={250}
                                    />
                                    {formError?.SupplierName && <div className='text-danger fs_14'>{formError?.SupplierName}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label">Email ID</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id="amEmail"
                                        name="amEmail"
                                        value={formValue.amEmail}
                                        onChange={(e: any) => handleOnChange(e.target.name, e.target.value)}
                                        disabled={disabled ? true : false}
                                        placeholder='Email ID'
                                        maxLength={150}
                                    />
                                    {formError?.amEmail && <div className='text-danger fs_14'>{formError?.amEmail}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label">Mobile Number</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <div className="input-group">
                                        <span className="input-group-text" id="prefixMobile"> +91 </span>
                                        <input className="form-control"
                                            type="text"
                                            id="amMobNo"
                                            name="amMobNo"
                                            value={formValue.amMobNo}
                                            onChange={(e: any) => handleOnChange(e.target.name, onlyNumeric(e.target.value))}
                                            disabled={disabled ? true : false}
                                            placeholder='Mobile Number'
                                            maxLength={10}
                                        />
                                    </div>
                                    {formError?.amMobNo && <div className='text-danger fs_14'>{formError?.amMobNo}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-12 col-md-12 col-sm-12 mt-3 mb-2'>
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <h5 className="">Manager</h5>
                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label required">Full Name</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id="ManagerName"
                                        name="mName"
                                        value={formValue.mName}
                                        onChange={(e: any) => handleOnChange(e.target.name, onlyAlphabets(e.target.value))}
                                        disabled={disabled ? true : false}
                                        placeholder='Full Name'
                                        maxLength={250}
                                    />
                                    {formError?.ManagerName && <div className='text-danger fs_14'>{formError?.ManagerName}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label required">Email ID</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id="EmailId"
                                        name="mEmail"
                                        value={formValue.mEmail}
                                        onChange={(e: any) => handleOnChange(e.target.name, e.target.value)}
                                        disabled={disabled ? true : false}
                                        placeholder='Email ID'
                                        maxLength={150}
                                    />
                                    {formError?.EmailId && <div className='text-danger fs_14'>{formError?.EmailId}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label required">Mobile Number</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <div className="input-group">
                                        <span className="input-group-text" id="prefixMobile"> +91 </span>
                                        <input className="form-control"
                                            type="text"
                                            id="MobileNo"
                                            name="mMobileNo"
                                            value={formValue.mMobileNo}
                                            onChange={(e: any) => handleOnChange(e.target.name, onlyNumeric(e.target.value))}
                                            disabled={disabled ? true : false}
                                            placeholder='Mobile Number'
                                            maxLength={10}
                                        />
                                    </div>
                                    {formError?.MobileNo && <div className='text-danger fs_14'>{formError?.MobileNo}</div>}
                                </div>

                            </div>
                        </div>
                        <div className="d-flex justify-content-center mt-4">
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleSaveUpdate} disabled={editDisabled || SupplierId <= 0}> {addbuttontext} </button>
                            <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClear} disabled={disabled || cleardisable}>Clear</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default ETMAccountManagemnet
